import { useMemo } from 'react';
import { getTestIds } from "./getTestIds";

/**
 * @deprecated don't use this overload, use the other one instead,
 * `deprecatedTestIds` is just for backwards compatibility and lazy migration
 */

export function useTestIds(arg) {
  return useMemo(() => {
    return getTestIds(arg);
  }, [arg]);
}